/**
 * Notice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ProfileSetEntry model module.
 * @module model/ProfileSetEntry
 * @version 1.0
 */
class ProfileSetEntry {
    /**
     * Constructs a new <code>ProfileSetEntry</code>.
     * @alias module:model/ProfileSetEntry
     */
    constructor() { 
        
        ProfileSetEntry.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ProfileSetEntry</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ProfileSetEntry} obj Optional instance to populate.
     * @return {module:model/ProfileSetEntry} The populated <code>ProfileSetEntry</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ProfileSetEntry();

            if (data.hasOwnProperty('EMAIL')) {
                obj['EMAIL'] = ApiClient.convertToType(data['EMAIL'], 'Boolean');
            }
            if (data.hasOwnProperty('APP')) {
                obj['APP'] = ApiClient.convertToType(data['APP'], 'Boolean');
            }
        }
        return obj;
    }


}

/**
 * Class ProfileSetEntry
 * @member {Boolean} EMAIL
 */
ProfileSetEntry.prototype['EMAIL'] = undefined;

/**
 * Class ProfileSetEntry
 * @member {Boolean} APP
 */
ProfileSetEntry.prototype['APP'] = undefined;






export default ProfileSetEntry;

